export const LANGUAGE_SET = 'LANGUAGE_SET';
export const LATESTYEAR_SET = 'LATESTYEAR_SET';
export const USE_COLOR_SET = 'USE_COLOR_SET';
export const CURRENT_DATA_VERSION_SET = 'CURRENT_DATA_VERSION_SET';
